

import { useChartResources } from "@chart";

export default function (callback) {
    //const TradingView = useChartResources('TradingView');
    //TradingView.stream.unsubscribe('chart');
    //TradingView.instance.bar = {};
}